import React, { useEffect, useState, useContext } from "react";
import api from "../../api/axiosConfig";
import {
  FaPlus,
  FaSync,
  FaToggleOn,
  FaToggleOff,
  FaTimes,
} from "react-icons/fa";
import { AuthContext } from "../../context/AuthContexto";

function MesaList() {
  const [mesas, setMesas] = useState([]);
  const [mostrarPanel, setMostrarPanel] = useState(false);
  const [nuevaMesa, setNuevaMesa] = useState("");

  const { usuario } = useContext(AuthContext);

  // Cargar mesas al iniciar
  useEffect(() => {
    obtenerMesas();
  }, []);

  const obtenerMesas = async () => {
    try {
      const response = await api.get("/mesas");
      setMesas(response.data);
    } catch (error) {
      console.error("Error al cargar las mesas:", error);
    }
  };

  const crearMesa = async () => {
    if (!nuevaMesa.trim()) {
      alert("Debes ingresar un número o código de mesa.");
      return;
    }

    try {
      await api.post("/mesas", { numero: nuevaMesa, ocupada: false });
      setNuevaMesa("");
      setMostrarPanel(false);
      obtenerMesas();
    } catch (error) {
      console.error("Error al crear la mesa:", error);
    }
  };

  const toggleEstado = async (mesa) => {
    try {
      await api.put(`/mesas/${mesa.numero}`, {
        ...mesa,
        ocupada: !mesa.ocupada,
      });
      obtenerMesas();
    } catch (error) {
      console.error("Error al cambiar estado de la mesa:", error);
    }
  };

  return (
    <div className="bg-white/95 text-slate-900 dark:bg-slate-900/90 dark:text-slate-100 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 p-6">
      {/* Encabezado */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
        <h2 className="text-lg font-semibold text-amber-500 dark:text-amber-300">
          Gestión de Mesas
        </h2>

        <div className="flex items-center gap-2">
          <button
            onClick={obtenerMesas}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border border-slate-400 dark:border-slate-600 text-xs sm:text-sm text-slate-700 dark:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          >
            <FaSync className="text-sky-500" />
            Actualizar
          </button>

          {usuario?.rol === "ADMIN" && (
            <button
              onClick={() => setMostrarPanel((prev) => !prev)}
              className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium text-white transition-colors ${
                mostrarPanel
                  ? "bg-red-500 hover:bg-red-600"
                  : "bg-emerald-500 hover:bg-emerald-600"
              }`}
            >
              {mostrarPanel ? <FaTimes /> : <FaPlus />}
              {mostrarPanel ? "Cerrar" : "Agregar Mesa"}
            </button>
          )}
        </div>
      </div>

      {/* Panel agregar mesa (solo ADMIN) */}
      {usuario?.rol === "ADMIN" && mostrarPanel && (
        <div className="mb-5 rounded-xl border border-emerald-500/40 bg-emerald-500/5 dark:bg-slate-800/60 p-4">
          <h3 className="text-center text-sm font-semibold text-emerald-500 mb-3">
            Nueva Mesa
          </h3>
          <div className="flex flex-col md:flex-row gap-3">
            <div className="flex-1">
              <input
                type="text"
                placeholder="Ejemplo: F1, M2, A3..."
                value={nuevaMesa}
                onChange={(e) => setNuevaMesa(e.target.value)}
                className="w-full rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900/70 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent"
              />
            </div>
            <div className="md:w-32">
              <button
                onClick={crearMesa}
                className="w-full inline-flex items-center justify-center px-3 py-2 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-sm font-semibold text-white transition-colors"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tabla de mesas */}
      <div className="mt-2 overflow-hidden rounded-xl border border-slate-200 dark:border-slate-800">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-100 dark:bg-slate-950/80">
            <tr>
              <th className="px-4 py-2 text-left font-semibold text-slate-700 dark:text-slate-100">
                Número
              </th>
              <th className="px-4 py-2 text-center font-semibold text-slate-700 dark:text-slate-100">
                Estado
              </th>
              <th className="px-4 py-2 text-center font-semibold text-slate-700 dark:text-slate-100">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {mesas.length > 0 ? (
              mesas.map((mesa) => (
                <tr
                  key={mesa.numero}
                  className="odd:bg-white even:bg-slate-50 dark:odd:bg-slate-900/60 dark:even:bg-slate-900/40 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                >
                  <td className="px-4 py-2 text-left font-medium">
                    {mesa.numero}
                  </td>
                  <td className="px-4 py-2 text-center">
                    <span
                      className={`inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-semibold border ${
                        mesa.ocupada
                          ? "bg-red-500/15 text-red-300 border-red-500/60"
                          : "bg-emerald-500/15 text-emerald-300 border-emerald-500/60"
                      }`}
                    >
                      {mesa.ocupada ? "Ocupada" : "Libre"}
                    </span>
                  </td>
                  <td className="px-4 py-2 text-center">
                    <button
                      onClick={() => toggleEstado(mesa)}
                      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors border ${
                        mesa.ocupada
                          ? "border-emerald-500 text-emerald-300 hover:bg-emerald-500 hover:text-slate-900"
                          : "border-red-500 text-red-300 hover:bg-red-500 hover:text-slate-900"
                      }`}
                    >
                      {mesa.ocupada ? (
                        <>
                          <FaToggleOff /> Liberar
                        </>
                      ) : (
                        <>
                          <FaToggleOn /> Ocupar
                        </>
                      )}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="3"
                  className="px-4 py-4 text-center text-slate-500 dark:text-slate-400 text-sm"
                >
                  No hay mesas registradas
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MesaList;
